import { Button, Select, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { Link, useParams } from "react-router-dom";
import AddIcon from "../../../../assets/icons/AddIcon";
import EditIcon from "../../../../assets/icons/EditIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CustomTable from "../../../../components/ui/CustomTable";

import {
  useGetAllRoleQuery,
  useGetUserListQuery,
} from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate } from "../../../../lib/time";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";
import UserProductAccessModal from "../UsersList/UserProductAccessModal";

const backLink = "/admin/users-roll-access/roll-access";

export default function RoleBaseProductList() {
  const {
    page,
    limit,
    handlePagination,
    handleLimit,
    filter,
    handleFilter,
    handleSearch,
    keyword,
  } = useTable<any>();
  const { companyId } = useParams();
  const { projectId } = useParams();
  const { projectName } = useParams();
  const { serviceName } = useParams();

  const {
    open: productActivityOpen,
    handleOpen: handleProductActivityOpen,
    handleClose: handleProductActivityClose,
  } = useModal<any, any>();

  const {
    isError: getAllUserIsError,
    error: getAllUserError,
    isLoading: getAllUserIsLoading,
    data: getAllUserData,
  } = useGetUserListQuery(
    {
      id: Number(projectId),
      skip: undefined,
      page,
      limit,
      companyId: Number(companyId),
      roleId: filter?.roleId,
    },
    {
      skip: !companyId || !projectId,
    }
  );

  const {
    isError: isAllRoleError,
    error: allRoleError,
    data: allRoleData,
  } = useGetAllRoleQuery(
    {
      params: {
        projectId: Number(projectId),
      },
    },
    {
      skip: !projectId,
    }
  );

  useError(getAllUserIsError, getAllUserError, "Get all user data fail");
  useError(isAllRoleError, allRoleError, "Get all user role data fail");

  const allsRollData = allRoleData?.data?.data;

  const columns: ColumnsType<any> = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: <div className="text-nowrap">Employee ID</div>,
      dataIndex: "userId",
      align: "center",
      render: (val) => {
        return val ? val : "N/A";
      },
    },

    {
      title: <div className="text-nowrap">Employee Name</div>,
      dataIndex: "user",
      render: (val) => {
        return val ? capitalize(val?.username) : "N/A";
      },
    },

    {
      title: <div className="text-nowrap">Assigned Role</div>,
      dataIndex: "role",
      align: "center",
      render: (val) => {
        return val ? capitalize(val?.roleName) : "N/A";
      },
    },

    {
      title: <div className="text-nowrap">Created at</div>,
      dataIndex: "created_at",
      align: "center",
      render: (val) => {
        return val ? formatDate(val) : "N/A";
      },
    },

    {
      title: <div className="whitespace-nowrap">Status</div>,
      dataIndex: "status",
      align: "center",
      render: (val: string) => {
        const statusClasses: Record<string, string> = {
          active: "bg-green-100 text-green-700",
          inactive: "bg-red-100 text-red-700",
        };

        return (
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${
              statusClasses[val.toLowerCase()] ||
              "bg-yellow-100 text-yellow-700"
            }`}
          >
            {val.charAt(0).toUpperCase() + val.slice(1)}
          </span>
        );
      },
    },

    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val: number, record: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Tooltip title="Edit Role Status">
              <Button
                onClick={() =>
                  handleProductActivityOpen({
                    type: "PRODUCT_ACTIVITY",
                    data: record,
                  })
                }
                className="action-button"
                size="small"
                icon={<EditIcon />}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <SidebarLayout title={`${projectName}`} backLink={backLink}>
        <CustomTable
          loading={getAllUserIsLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={getAllUserData?.data?.pagination?.total}
          dataSource={addKeyInArray(getAllUserData?.data?.users)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Select
                placeholder="Select Role"
                options={
                  allsRollData?.map((role: any) => {
                    let label = role?.roleName;

                    if (label === "edatco") {
                      label = "Admin";
                    } else if (label === "region") {
                      label = "Zonal";
                    } else if (label?.length <= 3) {
                      label = label?.toUpperCase();
                    }

                    return {
                      label,
                      value: role?.id,
                    };
                  }) || []
                }
                value={filter?.roleId ?? undefined}
                onChange={(value) => handleFilter("roleId", value)}
                className="!min-w-[200px]"
                suffixIcon={<SelectDownIcon />}
                allowClear
              />

              <Link
                to={`/admin/users-roll-access/roll-access/product-access/${companyId}/${projectId}/${projectName}/${serviceName}/add`}
              >
                <Button
                  type="primary"
                  className="middle-button"
                  icon={<AddIcon />}
                >
                  Assign Role
                </Button>
              </Link>
            </>
          }
        />
      </SidebarLayout>

      {productActivityOpen?.type === "PRODUCT_ACTIVITY" && (
        <UserProductAccessModal
          title=""
          subTitle=""
          buttonName="Send"
          open={productActivityOpen?.open}
          data={productActivityOpen?.data}
          handleClose={handleProductActivityClose}
          action
          buttonBgDeep
          loading={getAllUserIsLoading}
          id={productActivityOpen?.data?.userId}
          name={productActivityOpen?.data?.user?.username}
        />
      )}
    </>
  );
}
